import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://9a31a2101236557ce838f0f1acdbc913@o4509802933518336.ingest.us.sentry.io/4509807381512192",
  release: import.meta.env.VITE_REACT_APP_VERSION || "unknown",
  environment: import.meta.env.MODE || "development",

  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      // Add session replay
      maskAllText: true,
      blockAllMedia: true,
    }),
  ],

  tracePropagationTargets: ["localhost", /^https:\/\/admin.betkumi\.com/],
  tracesSampleRate: import.meta.env.MODE === "production" ? 0.2 : 1.0,
  replaysSessionSampleRate: 0.1, // Sample 10% of sessions
  replaysOnErrorSampleRate: 1.0, // Capture all error replays

  sendDefaultPii: false,
  maxBreadcrumbs: 50,
  attachStacktrace: true,

  beforeSend(event) {
    if (typeof window !== "undefined") {
      event.tags = {
        ...event.tags,
        route: window.location.pathname,
      };
      event.extra = {
        ...event.extra,
        query: Object.fromEntries(new URLSearchParams(window.location.search)),
      };
    }

    if (event.request?.headers) {
      delete event.request.headers["Authorization"];
    }

    if (event.user) {
      // Preserve useful identifiers while removing PII
      event.user = {
        id: event.user.id,
        username: event.user.username,
      };
    }

    return event;
  },
});

// Export Sentry and ErrorBoundary for component usage
export const SentryErrorBoundary = Sentry.ErrorBoundary;
export default Sentry;
